module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accesstoken),
      expression: "accesstoken"
    }],
    staticClass: "txt",
    attrs: {
      "type": "tel",
      "name": "",
      "id": "",
      "placeholder": "请输入Token"
    },
    domProps: {
      "value": (_vm.accesstoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accesstoken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn js-btn-login",
    on: {
      "click": _vm.signIn
    }
  }, [_vm._v("登录")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png"),
      "alt": "logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-373254b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 45
// module chunks = 0